import React from 'react'
import HeadingInspector from '@/components/HeadingInspector'

interface PopoverHeaderProps {
  title: string
  showClose?: boolean
  onClose?: () => void
  gap?: number
  children?: React.ReactNode
}

function PopoverHeader({ title, showClose, onClose }: PopoverHeaderProps) {
  return (
        <HeadingInspector
          title={title}
          hasNavigation={false}
          hasClose={showClose}
          handleClose={onClose}
          compactTitle
          style={{
            padding: 0,
            paddingLeft: 0,
            paddingRight: 0,
            height: 32,
            minHeight: 32,
            boxShadow: 'none',
          }}
        />
  )
}

export default PopoverHeader
